import request from "../utils/request";

export function GetNotifications(payload) {
    return request({
        url: "/Bell/getListBellBySite",
        method: "post",
        data: payload,
    });
}

export function GetListWarningDataByDivice(payload) {
    return request({
        url: "/Bell/getListWarningDataByDivice",
        method: "post",
        data: payload,
    });
}

export function ExporWarrningDataToFile(payload) {
    return request({
        url: "/Bell/exporWarrningDataToFile",
        method: "post",
        data: payload,
        responseType: "blob"
    });
}

export function GetListWarningDataByStore(payload) {
    return request({
        url: "/Bell/getListWarningDataByStore",
        method: "post",
        data: payload,
    });
}

export function GetListWarningDataByStorePaging(payload) {
    return request({
        url: "/Bell/getListWarningDataByStorePaging",
        method: "post",
        data: payload,
    });
}

